import { ActionTree } from "vuex";
import { SearchState } from "../models/store-viewmodel";
import SearchService from "../services/azure-search-service";
import ServiceNowService from "../services/service-now-service";
import HttpService from "@/shared/services/http-service";

export default <ActionTree<SearchState, SearchState>>{
  async loadData({ getters, commit }) {
    try {
      commit("setLoading", true);

      let result = await SearchService.search(
        getters.query,
        getters.azureService
      );
      commit("setSearchResults", result);

      if (getters.loadEmployeeResults) {
        let employeeResult = await ServiceNowService.search(
          getters.config,
          getters.searchQuery,
          HttpService
        );
        commit("setEmployeeResults", employeeResult);
      }
    } catch (error) {
      commit("setError", getters.errorText);
    } finally {
      commit("setLoading", false);
    }
  },
  onChange({ getters, dispatch }) {
    let memorySearch = getters.searchQuery;
    if (getters.searchQuery && getters.searchQuery.length > 1) {
      setTimeout(() => {
        if (memorySearch === getters.searchQuery) {
          dispatch("loadData");
        }
      }, 500);
    } else {
      dispatch("clearSearch");
    }
  },
  clearSearch({ commit }) {
    commit("setLoading", true);
    commit("setSearchQuery", "");
    commit("setSearchResults", {});
  },
  init(context, configRaw) {
    try {
      context.commit("setConfig", configRaw);
      context.commit("setAzureSearch");
    } catch (error) {
      context.commit("setError", context.getters.errorText);
    }
  },
};
